import { ThrottlingHandler } from './ThrottlingHandler';

/** Handles throttling jQuery issued requests. */
export class JQueryThrottlingHandler extends ThrottlingHandler {

    /**
     * @param makeRequest Issues the request that could result in throttling.
     * @param requestThrottled Executed whenever a throttled response is encountered.
     */
    constructor(makeRequest: (activityId: string) => void, requestThrottled?: (activityId: string, retryDelay: string, retryAttempt: number, retrying: boolean) => void) {
        super(makeRequest, requestThrottled);
    }

    /**
     * Handles a potentially throttled response, taking in the received jQuery failure. This method must be called whenever a
     * failed jQuery response is received.
     * @param jqXHR The jQuery failure object.
     * @returns A value indicating whether the response was in fact throttled and a subsequent retry was attempted.
     */
    public handleThrottleResponse(jqXHR: JQuery.jqXHR<any>): boolean {
        return super.handleThrottleResponseInternal(jqXHR?.status, jqXHR?.getResponseHeader && (jqXHR?.getResponseHeader("Retry-After") || jqXHR?.getResponseHeader("retry-after")));
    }
}
